import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import { Dimmer } from "../components/spinner";
import useTableScroll from "../components/useTableScroll.js";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import axios from "axios";

const CatalogoPersonaWeb = (props) => {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const btnCancela = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({});
  const [activo, setActivo] = useState(true);
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    { label: "CÉDULA", textAlign: "center" },
    { label: "APELLIDOS", textAlign: "center" },
    { label: "NOMBRES", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.cedula.includes(target.value) ||
              x.apellidos.toLowerCase().includes(target.value.toLowerCase()) ||
              x.nombres.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarPersonasTodas = () => {
    let endpoint = `${op.conexion}/api/catalogo/personas`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          var perso = [];
          for (let i = 0; i < response.data.length; i++) {
            perso.push({
              cedula: response.data[i].cedula,
              nombres: response.data[i].nombres,
              apellidos: response.data[i].apellidos,
              correoe: response.data[i].correoe,
              tlf1: response.data[i].tlf1,
              tlf2: response.data[i].tlf2,
              fnacimiento: response.data[i].fnacimiento,
              nacionalidad: response.data[i].nacionalidad,
              sexo: response.data[i].sexo,
              direccion: response.data[i].direccion,
            });
          }
          setRecords(perso);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const blanquear = () => {
    setItemSelect("");
    setActivate(false);
    setRecords([]);
    setActivo(true);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelaCatPer();
  };

  const seleccionarPersona = (index) => (event) => {
    var cedPer = values[0].cedPer;
    var nomPer = values[0].nomPer;
    var apePer = values[0].apePer;
    var correoPer = values[0].correoPer;
    var tlf1Per = values[0].tlf1Per;
    var tlf2Per = values[0].tlf2Per;
    var fnacPer = values[0].fnacPer;
    var nacPer = values[0].nacPer;
    var sexoPer = values[0].sexoPer;
    var direPer = values[0].direPer;

    blanquear();
    props.onHideAceptaCatPer(
      cedPer,
      nomPer,
      apePer,
      correoPer,
      tlf1Per,
      tlf2Per,
      fnacPer,
      nacPer,
      sexoPer,
      direPer
    );
  };

  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
    setActivo(false);
    var cedPer = recordsAfterPagingAndSorting()[index].cedula;
    var nomPer = recordsAfterPagingAndSorting()[index].nombres;
    var apePer = recordsAfterPagingAndSorting()[index].apellidos;
    var correoPer = recordsAfterPagingAndSorting()[index].correoe;
    var tlf1Per = recordsAfterPagingAndSorting()[index].tlf1;
    var tlf2Per = recordsAfterPagingAndSorting()[index].tlf2;
    var fnacPer = recordsAfterPagingAndSorting()[index].fnacimiento;
    var nacPer = recordsAfterPagingAndSorting()[index].nacionalidad;
    var sexoPer = recordsAfterPagingAndSorting()[index].sexo;
    var direPer = recordsAfterPagingAndSorting()[index].direccion;

    var datos = [];
    datos.push({
      cedPer,
      nomPer,
      apePer,
      correoPer,
      tlf1Per,
      tlf2Per,
      fnacPer,
      nacPer,
      sexoPer,
      direPer,
    });
    setValues(datos);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarPersonasTodas();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Seleccionar Persona</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} />
        <div className="col-md-12" style={{ marginBottom: "10px" }}>
          <div className="row">
            <div className="input-group col-md-2 input-group-sm mb-3">
              <input
                type="text"
                onChange={handleSearch}
                className="form-control"
              />
              <button
                className="btn btn-info"
                style={{ pointerEvents: "none" }}
              >
                <i className="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={item.cedula}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.cedula}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.apellidos}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.nombres}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          style={{ margin: "5px" }}
          onClick={seleccionarPersona()}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoPersonaWeb;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoPersonaWeb.js